document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".block-customers .swiper");
  [...blocks].forEach((item) => {
    const delayvalue = item.dataset.autoplay;
    const { slideperview, slideperviewmobile } = item.dataset;
    const breakpoints = { 320: {}, 1024: {} };
    let autoplay = false;
    if (typeof delayvalue !== "undefined") {
      autoplay = {
        delay: delayvalue * 1000,
      };
    }

    if (typeof slideperviewmobile !== "undefined") {
      breakpoints["320"].slidesPerView = Number(slideperviewmobile);
    }
    if (typeof slideperview !== "undefined") {
      breakpoints["1024"].slidesPerView = Number(slideperview);
    }

    const swiper = new Swiper(item, {// eslint-disable-line
      // eslint-disable-line
      // Optional parameters
      breakpoints,
      loop: true,
      autoplay,
      spaceBetween: 38,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
});
